// extracted by mini-css-extract-plugin
export default {"ShippingAddress":"ShippingAddress_ShippingAddress__kM9RT"};